import { Settings2 } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";
import { useLocale } from "../i18n/index.ts";
import { useSession } from "./session.ts";

/** Header entry to the admin UI: only rendered for a logged-in moderator or admin. */
export function AdminLink() {
  const { t } = useTranslation();
  const locale = useLocale();
  const { staff } = useSession();
  if (!staff) return null;
  return (
    <Link
      to={`/${locale}/admin/spots`}
      aria-label={t("admin.menu")}
      title={t("admin.menu")}
      className="ds-btn ds-btn--icon ds-btn--glass ds-glass ds-glass--clear"
    >
      <Settings2 aria-hidden="true" strokeWidth={1.75} />
    </Link>
  );
}
